<div class="position-relative">
  <div class="item-image">
    <!--Sponsor-->
    <ng-container *ngIf="lottoItem?.Sponsor?.SponsorImage">
      <div class="corner-icon-container-sponsor">
        <a target="_blank" href="{{ lottoItem.Sponsor?.SponsorLink }}">
          <img src="{{ lottoItem.Sponsor?.SponsorImage | contentImage: '6' : 'lotto' }}" />
        </a>
      </div>
    </ng-container>
    <a
      class="loyalty-item-container lotto"
      [owlRouterLink]="'/rewards/raffles/details/' + lottoItem.LottoId"
      [stopLink]="ignoreLink"
      id="lotto-link"
    >
      <div class="card loyalty border-0">
        <div>
          <img
            class="card-img-top"
            [src]="lottoItem.ImageName | contentImage: '7' : 'lotto'"
            [alt]="lottoItem.Title"
            [useDefault]="true"
            [loyaltyType]="'lotto'"
            draggable="false"
          />

          <div class="corner-number-entries" *ngIf="lottoItem.NumberOfTicketsPurchased">
            <span class="number-entries"> {{ ('lotto.my.entries' | translate) + lottoItem.NumberOfTicketsPurchased }} </span>
          </div>
        </div>
      </div>
    </a>
  </div>
  <div class="rewards-status-separator justify-content-between align-items-center">
    <ng-container *ngIf="statusText || lottoItem.Locked; else stockAvailableStates">
      @if (lottoItem.Locked) {
        <div class="rewards-item-panel-status text-info">
          <span class="icon material-icons me-1 rewards-locked-icon">lock</span>
          {{ 'reward.status.locked' | translate }}
        </div>
      } @else if (statusText) {
        <div class="rewards-item-panel-status {{ 'status-text-on-' + theme }}">{{ statusText | translate }}</div>
      }
    </ng-container>
    <!--Item State-->
    <ng-template #stockAvailableStates>
      <ng-container *ngIf="stockAvailableState">
        <div class="rewards-item-panel-status  {{ textColor }}">
          <ng-container *ngIf="stockAvailableState == LOTTO_STATE.FEATURED">
            <span class="icon material-icons text-success font-size-20 me-1">{{ featuredIcon }}</span>
          </ng-container>

          <span class="item-state">{{ stockAvailableState | translate }}</span>
        </div>
      </ng-container>
    </ng-template>

    <ng-container *ifItemEnabled="lottoItem; disabledStatus: [state.COMING_SOON, state.SOLD_OUT, state.LOCKED]">
      <fgbcl-countdown
        attr.aria-label="{{ 'lotto.details.countdown.screenreader' | translate }}"
        class="font-size-14 text-danger lotto-state-timer"
        [endDateTime]="lottoItem.EndDate"
      ></fgbcl-countdown>
    </ng-container>
  </div>

  <div class="rewards-item-panel-name">{{ lottoItem.Title }}</div>

  <label class="accessibility-only">Points Value: </label>

  @if (lottoItem.PurchasePrice > 0 || !showPts) {
    <div class="rewards-item-panel-value">{{ lottoItem.PurchasePrice | FortressCurrencyPipe: 'PTS' }}</div>
  } @else {
    <div class="rewards-item-panel-value">{{ 'fgbcl.lottos.item.free' | translate }}</div>
  }
</div>
